import { render, staticRenderFns } from "./ActionItemsCard.vue?vue&type=template&id=c02b8544&scoped=true&"
import script from "./ActionItemsCard.vue?vue&type=script&lang=js&"
export * from "./ActionItemsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02b8544",
  null
  
)

export default component.exports